import { makeStyles } from "@material-ui/core/styles";
import { useCallback, useEffect, useState } from "react";
import { Search } from "react-bootstrap-table2-toolkit";

import {
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";

import {
  Add as AddIcon,
  CloudDownload,
  Create,
  Refresh as RefreshIcon,
} from "@material-ui/icons";

import { Skeleton } from "@material-ui/lab";

import componentStyles from "assets/theme/components/cards/sortable/card-light-table-sortable";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import IconButtonLoader from "components/Buttons/IconButtonLoader";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import ToggleCell from "components/Cells/ToggleCell";
import FormUserDialog from "components/Dialogs/FormUserDialog";
import HeaderClientes from "components/_refactor/headers/clients";
import LoadingData from "components/Loading/LoadingData";
import useLogs from "hooks/logs";
import { useVisionLogin } from "hooks/useVisionLogin";
import { useWebsocketFetch } from "hooks/useWebsocketFetch";
import Api from "lib/api/httpRequestHelper";
import { utils, writeFileXLSX } from "xlsx";
import { IsMobile } from "utils/is-mobile";
import FilterCard from "components/_refactor/filter-card";
import AutoCompleteField from "components/_refactor/fields/autocomplete";

import { API_ENV } from "constants/environment";

const STATUS_OPTIONS = [
  {
    value: "ATIVO",
    name: "Ativo",
    id: 1,
  },
  {
    value: "INATIVO",
    name: "Inativo",
    id: 1,
  },
];

const getTableColumns = (
  setSelectedUser,
  toggleFormDialog,
  searching,
  toggleField
) => [
  {
    dataField: "IdUsuario",
    text: "IdUsuario",
    sort: true,
    align: "center",
    formatter: (data) => (searching ? <Skeleton variant="text" /> : data),
  },
  {
    dataField: "Nome",
    text: "Nome",
    sort: true,
    formatter: (data) => (searching ? <Skeleton variant="text" /> : data),
  },
  {
    dataField: "Login",
    text: "Login",
    sort: true,
    formatter: (data) => (searching ? <Skeleton variant="text" /> : data),
  },
  {
    dataField: "Perfis",
    text: "Perfis",
    hidden: true,
  },
  {
    dataField: "UsuarioPerfis",
    text: "Perfis",
    sort: false,
    formatter: (profiles) => {
      const profilesList = [];
      profiles?.map((profile) => {
        profilesList.push(profile?.Nome);
      });
      return searching ? (
        <Skeleton variant="text" />
      ) : (
        <>
          {profilesList?.map((profile) => (
            <Chip
              key={profile}
              style={{
                color: profile === "ADM" ? "white" : "#3f3f3f",
                border: "1px solid #3f3f3f",
                backgroundColor: profile === "ADM" ? "#3f3f3f" : "white",
                margin: "1px 1px",
                padding: "0.25rem 0.5rem",
                fontSize: "11px",
              }}
              variant="outlined"
              label={profile}
              size="small"
            />
          ))}
        </>
      );
    },
  },
  {
    dataField: "Inativo",
    text: "Inativo",
    headerStyle: { width: 90 },
    formatter: (cell, row) => {
      return (
        <ToggleCell
          initialValue={row.Inativo}
          handleChange={async (params) => {
            row.Inativo = params.Inativo;

            await toggleField({ ...row, ...params }, "Inativo");
          }}
          initialLoading={searching}
          field="Inativo"
        />
      );
    },
    sort: true,
  },
  {
    dataField: "Backoffice",
    text: "Backoffice",
    headerStyle: { width: 90 },
    formatter: (cell, row) => {
      return (
        <ToggleCell
          initialValue={row.Backoffice}
          handleChange={async (params) => {
            row.Backoffice = params.Backoffice;

            await toggleField({ ...row, ...params }, "Backoffice");
          }}
          initialLoading={searching}
          field="Backoffice"
        />
      );
    },
    sort: true,
  },
  {
    dataField: "editar",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => {
      return searching ? null : (
        <Tooltip title="Editar Usuário">
          <IconButton
            aria-label="edit"
            onClick={() => {
              setSelectedUser(row);
              toggleFormDialog("edit");
            }}
          >
            <Box
              component={Create}
              width="1.25rem!important"
              height="1.25rem!important"
            />
          </IconButton>
        </Tooltip>
      );
    },
    headerStyle: { width: 45 },
  },
];

const loadingItems = [
  { IdUsuario: "0" },
  { IdUsuario: "1" },
  { IdUsuario: "2" },
  { IdUsuario: "3" },
  { IdUsuario: "4" },
  { IdUsuario: "5" },
  { IdUsuario: "6" },
  { IdUsuario: "7" },
  { IdUsuario: "8" },
  { IdUsuario: "9" },
];

const { SearchBar } = Search;

const useStyles = makeStyles(componentStyles);

function Usuarios() {
  const classes = useStyles();
  const snackbar = useSnackbar();
  const { setLocalStorageActions, setLocalStorageApiProblem } = useLogs();

  const [users, setUsers] = useState(loadingItems);
  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searching, setSearching] = useState(true);
  const [status, setStatus] = useState();
  const [profiles, setProfiles] = useState([]);
  const [listProfile, setListProfile] = useState([]);
  const isMobile = IsMobile();
  const itemXS = isMobile ? 12 : 4;

  const toggleFormDialog = useCallback((formType) => {
    if (formType) {
      setOpenFormDialog(formType);
    }
  }, []);

  const toggleField = useCallback(
    (row, field) => {
      return Api.postParams(
        "update-user",
        "adminportal",
        "?nome=" +
          row.Nome +
          "&idUsuario=" +
          row.IdUsuario.toString() +
          "&login=" +
          row.Login +
          "&backoffice=" +
          row.Backoffice.toString() +
          "&inativo=" +
          row.Inativo.toString(),
        true
      )
        .then((res) => {
          if (res.Success) {
            if (field === "Inativo") {
              snackbar.showMessage(
                `Usuário ${res.Result.IdUsuario.toString()} foi ${
                  res.Result.Inativo ? "inativado" : "ativado"
                } com sucesso!`,
                {
                  severity: "success",
                }
              );
            } else if (field === "Backoffice") {
              snackbar.showMessage(
                `Backoffice do Usuário ${res.Result.IdUsuario.toString()} foi ${
                  res.Result.Backoffice ? "ativado" : "desativado"
                } com sucesso!`,
                {
                  severity: "success",
                }
              );
            }
          } else {
            snackbar.showMessage(
              `Ocorreu um erro ao atualizar informação do Usuário ${res.Result.IdUsuario.toString()}. Verifique os parâmetros informados.`,
              {
                severity: "error",
              }
            );
          }
        })
        .catch((error) => {
          snackbar.showMessage(error, {
            severity: "error",
          });
          setLocalStorageApiProblem({
            idMenuAccess: "58",
            screen: "Usuários",
            problem: `Erro na chamada do endpoint update-user - ${error}`,
          });
        });
    },
    [snackbar]
  );

  const updateList = async (updatedProfile) => {
    const newProfileList = users?.map((user) => {
      if (user.IdUsuario === updatedProfile.IdUsuario) return updatedProfile;
      else return user;
    });

    setUsers(newProfileList);
  };

  const fetchList = async () => {
    setSearching(true);
    await Api.get(
      "list-user",
      "adminportal",
      `?status=${status ? status.value : ""}` +
        `&idPerfil=${
          profiles?.length
            ? profiles.map((item) => item.IdPerfil).join(",")
            : ""
        }`
      , true
    )
      .then(({ Success, Result }) => {
        if (Success) {
          setUsers(Result);
          setSearching(false);

          const searchParams = new URLSearchParams(window.location.search);
          if (searchParams.get("action") === "create-user") {
            setOpenFormDialog("create");
          }
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "58",
          screen: "Usuários",
          problem: `Erro na chamada do endpoint list-user - ${error}`,
        });
      });
  };

  const fetchProfiles = useCallback(() => {
    return Api.get(
      "list-profile",
      "adminportal",
      "?situacaoPerfil=ativos",
      true
    )
      .then(({ Success, Result }) => {
        if (Success) {
          if (Result.length === 0) {
            setListProfile([]);
          } else {
            setListProfile(Result);
          }
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "58",
          screen: "Usuários",
          problem: `Erro na chamada do endpoint list-profile - ${error}`,
        });
      });
  }, [snackbar, setLocalStorageApiProblem]);

  const handleRefresh = async () => {
    setSearching(true);

    return fetchList();
  };

  const handleStopSearching = () => {
    setSearching(false);
    setStatus(null);
    setProfiles([]);
  };

  useEffect(() => {
    fetchList();
    fetchProfiles();
    setLocalStorageActions({
      nomeTela: "Usuários",
      idMenu: "58",
      acao: "Acessou o menu Usuários",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { userId } = useVisionLogin();

  const {
    handleFetchData: handleFetchUsersToExport,
    status: wsStatus,
    handleFetchUrl: connectToUserExportWebsocket,
  } = useWebsocketFetch({
    onSuccess: (data) => {
      const json = data.reduce((sheet, userToExport) => {
        return [
          ...sheet,
          ...userToExport.UsuarioLoja.map((store) => ({
            Login: userToExport.Login,
            Perfis: userToExport.UsuarioPerfis.map(
              (perfil) => perfil.Nome
            ).join(", "),
            CNPJ: store.CnpjCpfPessoa,
            "Razão Social": store.Apelido,
          })),
          {
            Login: "",
            Perfis: "",
            CNPJ: "",
            "Razão Social": "",
          },
        ];
      }, []);

      const receipt = utils.json_to_sheet(json);

      const wb = utils.book_new();
      utils.book_append_sheet(wb, receipt, "Vinculo Usuário-Lojas");
      writeFileXLSX(wb, "Vinculo Usuário-Lojas.xlsx");
    },
  });

  const handleSendMessage = () => {
    handleFetchUsersToExport({
      action: "user-list",
      params: {
        querystring: {
          idPerfil: "",
          nome: "",
          email: "",
          status: "",
        },
        header: {
          "K-IdUser": userId,
        },
      },
    });
    snackbar.showMessage("Aguarde exportação dos usuários.", {
      severity: "info",
      autoHideDuration: 60000,
    });
  };

  const handleClearFilters = () => {
    setStatus(null);
    setProfiles([]);
  };

  useEffect(() => {
    connectToUserExportWebsocket(
      `wss://cw9qfq2tvl.execute-api.us-east-1.amazonaws.com/${API_ENV}`
    );
  }, []);

  return (
    <>
      <HeaderClientes section="Usuários" subsection="Administração" />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={fetchList}
          disabled={searching}
          searching={searching}
          handleClearFilters={handleClearFilters}
        >
          <Grid item xs={itemXS}>
            <AutoCompleteField
              options={STATUS_OPTIONS}
              label="Status"
              onChange={setStatus}
              optionLabelKey="name"
              optionIdKey="id"
              value={status}
              disabled={searching}
              loading={searching}
            />
          </Grid>

          <Grid item xs={itemXS}>
            <AutoCompleteField
              options={listProfile}
              label="Perfil"
              onChange={setProfiles}
              optionIdKey="Nome"
              value={profiles}
              disabled={searching}
              loading={searching}
              multiple
            />
          </Grid>
        </FilterCard>

        <Grid container>
          <Grid item xs={12}>
            <LoadingData
              searching={searching}
              onClick={() => handleStopSearching()}
              classes={classes.root}
              label="Buscando dados..."
            />

            <Card classes={{ root: classes.cardRoot }}>
              <ToolkitTable
                keyField="IdUsuario"
                dataTable={searching ? loadingItems : users}
                columnModel={getTableColumns(
                  setSelectedUser,
                  toggleFormDialog,
                  searching,
                  toggleField
                )}
                search
                allowEmpty
                CustomHeader={({ searchProps }) => (
                  <Grid
                    container
                    className="pl-4"
                    style={{ padding: isMobile ? "0 24px 10px" : "0 24px" }}
                  >
                    <Grid item xs={12} sm={4}>
                      <Box
                        component={Typography}
                        variant="h2"
                        marginBottom="0!important"
                      >
                        <Box component="span">Lista de Usuários</Box>
                        <IconButtonLoader
                          size="medium"
                          extraStyle={{
                            width: 24,
                            height: 24,
                            marginLeft: "0.3rem",
                          }}
                          title="Recarregar lista"
                          onClick={handleRefresh}
                          icon={<RefreshIcon color="primary" />}
                          aria-label="refresh"
                          color="primary"
                          disabled={searching}
                        />
                      </Box>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={8}
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        justifyContent: isMobile ? "flex-start" : "flex-end",
                        flexDirection: isMobile ? "column" : "row",
                      }}
                    >
                      <SearchBar
                        className="form-control"
                        placeholder="Pesquisar Usuário"
                        {...searchProps}
                        disabled={searching}
                      />
                      <Box
                        justifyContent="flex-end"
                        display="flex"
                        flexWrap="wrap"
                        style={{ marginLeft: isMobile ? 0 : 15 }}
                      >
                        <Button
                          variant="contained"
                          classes={{
                            root: classes.buttonRootWhite,
                          }}
                          onClick={() => toggleFormDialog("create")}
                          disabled={searching}
                        >
                          <Box
                            component={AddIcon}
                            position="relative"
                            top="-2px"
                          />{" "}
                          Criar
                        </Button>
                      </Box>
                      <Box
                        justifyContent="flex-end"
                        display="flex"
                        flexWrap="wrap"
                        style={{ marginLeft: isMobile ? 0 : 15 }}
                      >
                        <Button
                          variant="contained"
                          classes={{
                            root: classes.buttonRootWhite,
                          }}
                          onClick={handleSendMessage}
                          disabled={wsStatus !== "on" || searching}
                        >
                          <Box
                            component={() =>
                              wsStatus === "fetching" ? (
                                <CircularProgress
                                  style={{
                                    marginRight: 6,
                                    width: 12,
                                    height: 12,
                                  }}
                                />
                              ) : (
                                <CloudDownload style={{ marginRight: 6 }} />
                              )
                            }
                            position="relative"
                            top="-2px"
                          />
                          {""}
                          Exportar Usuários
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                )}
                pagination={{
                  options: [25, 50, 100],
                  defaultOption: 25,
                }}
              />
            </Card>
          </Grid>
        </Grid>
      </Container>

      {Boolean(openFormDialog) && (
        <FormUserDialog
          open
          formType={openFormDialog}
          onClose={(user) => {
            setOpenFormDialog(null);
            setSelectedUser(null);
            if (user?.IdUsuario > 0) {
              if (openFormDialog === "create") {
                const newProfileList = [...users, { ...user }];

                setUsers(newProfileList);
              } else {
                updateList(user);
              }
            }
          }}
          selectedUser={selectedUser}
        />
      )}
    </>
  );
}

Usuarios.propTypes = {};

export default Usuarios;
